<div class="cm-tenant-login-container">
    @let busy = $busy();
    @let unknownTenant = $unknownTenant();
    <div class="cm-tenant-login-card">
        @if (unknownTenant) {
            <div class="cm-tenant-login-card-header">SSO not available</div>
            <div class="cm-message">This single sign-on link is not recognised. Please check the address or contact your administrator.</div>
        } @else {
            <div class="cm-tenant-login-card-header">Sign in with {{ $tenantName() }} SSO</div>
            @if (busy) {
                <mat-progress-spinner mode="indeterminate" [diameter]="24" color="primary"></mat-progress-spinner>
            } @else {
                <button class="cm-sign-in-button" type="button" (click)="signIn()">Continue with {{ $tenantName() }} SSO</button>
            }
        }
    </div>
</div>
